import { gql } from '@apollo/client'

export const GET_AIRCRAFT_LIST = gql`
  query GetAircraftList($orgSlug: String!) {
    aircrafts(orgSlug: $orgSlug) {
      id
      tailNumber
      model
      orgSlug
    }
  }
`

export const GET_MAINTENANCE_ITEMS = gql`
  query GetMaintenanceItems($aircraftId: String!, $orgSlug: String!) {
    maintenanceItems(
      maintenanceItemFilters: { aircraftIds: [$aircraftId], orgSlug: $orgSlug }
    ) {
      id
      title
      ataCode
      manufactureCode
      description
      ataMfgCodeNormalized
    }
  }
`

export const CREATE_TASK_RELATIONSHIP = gql`
  mutation CreateTaskRelationship($input: CreateTaskRelationshipInput!) {
    createTaskRelationship(input: $input) {
      id
      task1Id
      task2Id
      relationship
      isDirectional
      createdAt
    }
  }
`

export const GET_LINKED_TASKS = gql`
  query GetLinkedTasks($aircraftId: String!) {
    linkedTasks(aircraftId: $aircraftId) {
      id
      task1Id
      task2Id
      relationship
      isDirectional
      createdAt
      task1 {
        id
        title
        ataCode
        manufactureCode
        description
      }
      task2 {
        id
        title
        ataCode
        manufactureCode
        description
      }
    }
  }
`
